
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lawyers/[lawyerId]",
      function () {
        return require("private-next-pages/lawyers/[lawyerId]/index.tsx");
      }
    ]);
  